const DISMISS_KEY = 'calc_tip_dismissed';
const HOVER_CLOSE_DELAY = 250;

class CalcEntry extends HTMLElement {
  connectedCallback() {
    this.toggleBtn = this.querySelector('[data-calc-toggle]');
    this.tip = this.querySelector('.calc-tip');
    if (!this.toggleBtn || !this.tip) return;

    this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // 点击图标：展开 / 收起
    this.toggleBtn.addEventListener('click', () => this.setOpen(!this.isOpen));

    // 点击 ×：关闭，并记住，之后不再自动弹出（手动点图标仍可展开）
    this.querySelector('[data-calc-close]').addEventListener('click', () => {
      this.setOpen(false);
      this.remember();
    });

    // 桌面端：鼠标悬停展开，离开后稍作延迟再关闭
    if (this.canHover) {
      this.addEventListener('pointerenter', () => {
        clearTimeout(this.closeTimer);
        this.setOpen(true);
      });
      this.addEventListener('pointerleave', () => {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => this.setOpen(false), HOVER_CLOSE_DELAY);
      });
    }

    // 点击气泡外部关闭
    this.onDocClick = (e) => { if (this.isOpen && !this.contains(e.target)) this.setOpen(false); };
    // Esc 关闭
    this.onKeydown = (e) => { if (e.key === 'Escape' && this.isOpen) { this.setOpen(false); this.toggleBtn.focus(); } };
    document.addEventListener('click', this.onDocClick);
    document.addEventListener('keydown', this.onKeydown);

    // 首次访问自动弹出（需在主题编辑器里勾选；装修模式下不弹）
    const autoshow = this.dataset.autoshow === 'true';
    const inDesignMode = window.Shopify && window.Shopify.designMode;
    if (autoshow && !inDesignMode && !this.isRemembered()) {
      this.autoTimer = setTimeout(() => this.setOpen(true), 1500);
    }
  }

  disconnectedCallback() {
    clearTimeout(this.autoTimer);
    clearTimeout(this.closeTimer);
    document.removeEventListener('click', this.onDocClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  get isOpen() {
    return this.hasAttribute('data-open');
  }

  setOpen(open) {
    this.toggleAttribute('data-open', open);
    this.toggleBtn.setAttribute('aria-expanded', String(open));
  }

  isRemembered() {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  }

  remember() {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
  }
}

if (!customElements.get('calc-entry')) customElements.define('calc-entry', CalcEntry);